import { useState, useEffect, useContext } from "react";
import { Grid, Divider } from "@material-ui/core";
import { CircleProgress } from "../../../../../components/Overlay";
import { ReactOutlineInput } from "../../../../components/ReactTextField";
import { ConfirmDialogTS } from "../../../../components/ReactDialogTS";
import { ConfirmDialogPropsScroll, ConfirmDialogPropsSize } from "../../../../../js/types";
import { MainPageDialogContext } from "../../../../../js/MainPageDialogContext";
import { ResultObj, esd_storage } from "../../../../../js/Domain";
import { showUpWorkMakeUpPosition } from "../../../../../js/function";
import { useUserClockRecordPlaceApi, WorkClockParams } from "../../../../../js/adapter/UserClockRecordPlaceAdapter";
import { CustomDate } from "../../../../../utils/date/dateExtension";


type PunchCardFirstModalInnerPunchCardProps = {
    modalConfirm: () => void;
    modalClose: () => void;
    loadingTopLayer?: boolean;
};

const PunchCardFirstModalInnerPunchCard = ({ modalConfirm, modalClose, loadingTopLayer }: PunchCardFirstModalInnerPunchCardProps) => {
    const { responseMessage } = useContext(MainPageDialogContext);
    const userWorkApiManager = useUserClockRecordPlaceApi();

    const [isLoaded, setIsLoaded] = useState(false);
    const [pageAdd, setPageAdd] = useState<WorkClockParams>({});

    useEffect(() => {
        const init = async () => {
            try {
                const obj = await showUpWorkMakeUpPosition();
                if (obj.latitude === 0 && obj.longitude === 0) {
                    responseMessage({ success: false, message: "無法取得定位資訊，請確認裝置定位服務已開啟後再重試。", data: null });
                    modalClose();
                    return;
                }
                const today = new CustomDate()
                setPageAdd({
                    user_id: esd_storage.user_id,
                    longitude: obj.longitude,
                    latitude: obj.latitude,
                    date: today.toYYYYMMDD(),
                    time: today.toHHmmSS(),
                });
            } catch (error) {
                responseMessage(error as ResultObj);
            } finally {
                setIsLoaded(true);
            }
        };
        init();
    }, []);

    const handleConfirm = async () => {
        if (!userWorkApiManager) return;
        try {
            const res = await userWorkApiManager.WorkClock(pageAdd);
            modalConfirm();
            responseMessage({ ...res, data: null });
        } catch (error) {
            responseMessage(error as ResultObj);
        }
    };

    if (!isLoaded) return <CircleProgress topLayer={loadingTopLayer} />;

    return (
        <ConfirmDialogTS
            modalOpen={true}
            closeClick={modalClose}
            modal={{
                id: "punchCardModal",
                modaltitle: "打卡",
                messages: (
                    <Grid item lg={12} md={12} xs={12}>
                        <ReactOutlineInput
                            color="primary"
                            type="text"
                            id="add--longitude"
                            name="add--longitude"
                            value={pageAdd.longitude}
                            label="經度"
                            placeholder="尚未輸入"
                            required={true}
                            disabled={true}
                        />
                        <ReactOutlineInput
                            color="primary"
                            type="text"
                            id="add--latitude"
                            name="add--latitude"
                            value={pageAdd.latitude}
                            label="緯度"
                            placeholder="尚未輸入"
                            required={true}
                            disabled={true}
                        />
                        <div style={{ padding: "0.45rem", color: "#c10000" }}>注意：上下班時間將依系統伺服器時間記錄。</div>
                        <Divider variant="middle" style={{ margin: "1.5rem 0rem" }} />
                        <Grid item lg={12} md={12} xs={12} style={{ marginBottom: "1rem" }}>當前定位</Grid>
                        <iframe
                            src={`https://www.google.com/maps?q=${pageAdd.latitude},${pageAdd.longitude}&z=16&ie=UTF8&output=embed`}
                            style={{ border: 0, width: "100%", height: "350px" }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </Grid>
                ),
                size: ConfirmDialogPropsSize.XS,
                scroll: ConfirmDialogPropsScroll.BODY,
                modalAction: handleConfirm,
            }}
        />
    );
};

export default PunchCardFirstModalInnerPunchCard;
